import { Flex } from "../ui";
import type { ReactNode } from "react";
import { spacing } from "../settings/settingsListDesign";
import { SectionCardBase } from "../layout/SectionCard";
import { RepeatableAddButton, RepeatableRemoveButton } from "./RepeatableRows";

export interface RepeatableBlocksProps {
  addLabel: ReactNode;
  onAdd: () => void;
  disabled?: boolean;
  children?: ReactNode;
}

/** The established member form contract for repeatable cards, with labels supplied by the host. */
export function RepeatableBlocks({ addLabel, onAdd, disabled, children }: RepeatableBlocksProps) {
  return <Flex vertical gap={spacing.md}>
    {children}
    <RepeatableAddButton label={addLabel} onClick={onAdd} disabled={disabled} block />
  </Flex>;
}

export interface RepeatableBlockProps {
  title?: ReactNode;
  removeLabel: string;
  onRemove?: () => void;
  disabled?: boolean;
  extra?: ReactNode;
  children?: ReactNode;
}

export function RepeatableBlock({ title, removeLabel, onRemove, disabled, extra, children }: RepeatableBlockProps) {
  const headerExtra = <Flex align="center" gap={spacing.xs}>
    {extra}
    {onRemove != null && <RepeatableRemoveButton label={removeLabel} onClick={onRemove} disabled={disabled} />}
  </Flex>;
  return <SectionCardBase padding="compact" title={title}
    extra={title != null || extra != null || onRemove != null ? headerExtra : undefined}>
    {children}
  </SectionCardBase>;
}
